import { useDispatch } from 'react-redux';
import { useDashboardAPI } from '../../../hooks';
import { useQuery } from '@tanstack/react-query';
import { notificationsConfig } from '../../../config/constants';
import { error } from 'react-notification-system-redux';
import { useFarmId } from './useFarmId';
export const useFarmParams = () => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    const farmId = useFarmId();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        enabled: !!farmId,
        queryFn: () => api.farms.getFarmParams(farmId),
        select: (data) => data || {},
        queryKey: ['farmParams'],
    });
};
//# sourceMappingURL=useFarmParams.js.map